import { render, staticRenderFns } from "./SpecialInitiativesTopList.vue?vue&type=template&id=1a835568&scoped=true&"
import script from "./SpecialInitiativesTopList.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiativesTopList.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialInitiativesTopList.vue?vue&type=style&index=0&id=1a835568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a835568",
  null
  
)

export default component.exports